<template>
    <div class="page-layout blank contacts-manage">
        <div class="pl-3 pb-14">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <span @click="$router.go(-1)">Lead Dashboard</span>
                        <a> {{ lead_details.first_name || "-" }}</a>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <button @click="refresh()"
                            class="btn btn-des-small ml-2 text-white" style="background:#00448b; height:30px">Refresh
                        </button>
                        <button :disabled="lead_type != 'Manual' || lead_details.current_stage == 'qualified_lead'" @click="createSchedule()"
                            class="btn btn-des-small ml-2 text-white" style="background:#00448b; height:30px">+ Schedule Meeting
                        </button>
                        <button @click="viewLead(selected_lead_id)"
                            class="btn btn-des-small ml-2 mr-3 text-white" style="background:#00448b; height:30px"><i class="crmnew-user iconsize-13 iconsize pr-2" style="font-size: 14px; color: rgb(255, 255, 255);"></i>View Lead
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center h-100 mt-20" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-lg-9 col-md-12 col-sm-12 mt-2">
                        <div class="row">
                            <div class="col-lg-4 col-sm-12 col-md-4 pl-4 pr-0 mt-2" v-if="!expandprofile">
                                <fullscreen class="box-radius bg-white">
                                    <div class="card-item bg-white text-auto" style="height: 140px;">
                                        <div class="d-flex justify-content-between aling-items-center">
                                            <div class="fw-600 pr-5 fs-14 text-truncate" :title="lead_details.first_name" style="width: 60%;">{{ lead_details.first_name || "-" }}</div>
                                            <div>
                                                <div class="social-media-edit " v-for="(social, index) in social_media" :key="index" style="display: inline-block !important;">
                                                    <a :href="social.url" v-if="index <= 2" target="_blanck" style="text-decoration: none;">
                                                        <img v-if="social.media_type == 'Facebook'" src="/static/images/facebooks.svg" target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Twitter'" src="/static/images/twitters.svg"  target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Linkedin'" src="/static/images/linked.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Instagram'" src="/static/images/instgrams.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Reddit'" src="/static/images/Redditblue.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    </a>
                                                </div>
                                            </div>
                                            <div>
                                                <!-- <button class="pointer btn-icon" @click="editLead(lead_details)">
                                                    <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                                </button> -->
                                                <span class="circle-button ml-1 pointer" @click="expandProfile">
                                                    <i class="icon-chevron-down text-white org-icon-rotate-transition org-icon-down"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <hr style="border-top: 2px solid rgba(0,0,0,0.1) !important;">
                                        <div v-if="!expandprofile" class="fw-500 text-center d-flex justify-content-between aline-items-center mt-5" style="height:28px">
                                            <span
                                                class="text-left col-md-4 col-sm-4 col-lg-3 div-spacing" style="font-size: 12px;">Phone</span>
                                            
                                            <span
                                                class="text-left col-md-8 col-sm-8 col-lg-9 div-spacing text-truncate" :title=" lead_details.phone_number" style="font-size: 12px;">{{ phone_number || "-" }}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-1">
                                            <span
                                                class="text-left col-md-4 col-sm-4 col-lg-3 div-spacing" style="font-size: 12px;">Email ID</span>
                                            
                                            <span
                                                class="text-left col-md-8 col-sm-8 col-lg-9 div-spacing text-truncate" :title=" lead_details.lead_email" style="font-size: 12px;">{{ lead_details.lead_email || "-" }}</span>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                            <div class="col-lg-4 col-sm-12 col-md-4 pl-4 pr-0 mt-2" v-if="expandprofile">
                                <fullscreen class="box-radius bg-white">
                                    <div class="card-item bg-white text-auto" style="position: absolute;z-index: 999;width: 95%;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.7);">
                                        <div class="d-flex justify-content-between aling-items-center">
                                            <div class="fw-600 pr-5 fs-14 text-truncate" :title="lead_details.first_name">{{ lead_details.first_name || "-" }}</div>
                                            <!-- <div>
                                                <button class="pointer btn-icon" @click="editLead(lead_details)">
                                                    <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                                </button>
                                            </div> -->
                                        </div>
                                        <hr style="border-top: 2px solid rgba(0,0,0,0.1) !important;">
                                        <div style="height:100%;">
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Company Name</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title=" lead_details.company_name" style="font-size: 12px;">{{ lead_details.company_name || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Phone</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title=" lead_details.phone_number" style="font-size: 12px;">{{ phone_number || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Email ID</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title=" lead_details.lead_email" style="font-size: 12px;">{{ lead_details.lead_email || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Lead Type</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate text-capitalize" :title=" lead_details.lead_type" style="font-size: 12px;">{{ lead_details.lead_type.replaceAll('_', ' ') || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Source</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate text-capitalize" :title=" lead_details.lead_source" style="font-size: 12px;">{{ lead_details.lead_source.replaceAll('_', ' ') || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                                <span
                                                    class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Introduced</span>
                                                
                                                <span
                                                    class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title=" lead_details.created_time.date" style="font-size: 12px;">{{convertDate(lead_details.created_time.date) || "-" }}</span>
                                            </div>
                                            <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2" v-if="lead_details.lead_source == 'social_media'">
                                                <span class="text-left col-md-12 col-sm-12 col-lg-12 div-spacing" style="font-size: 12px;">Social Media</span>
                                            </div>
                                            <div class="row d-flex pt-2">
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                                                    <div class="social-media-edit " v-for="(social, index) in social_media" :key="index" style="display: inline-block !important;text-align: left !important;">
                                                        <a :href="social.url" target="_blanck" style="text-decoration: none;">
                                                            <img v-if="social.media_type == 'Facebook'" src="/static/images/facebooks.svg" target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                            <img v-if="social.media_type == 'Twitter'" src="/static/images/twitters.svg"  target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                            <img v-if="social.media_type == 'Linkedin'" src="/static/images/linked.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                            <img v-if="social.media_type == 'Instagram'" src="/static/images/instgrams.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                            <img v-if="social.media_type == 'Reddit'" src="/static/images/Redditblue.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="text-align: right !important;display: inline-block !important;">
                                                    <span class="circle-button ml-1 pointer" @click="expandProfile">
                                                        <i class="icon-chevron-up text-white org-icon-rotate-transition org-icon-down"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                            <div class="col-lg-8 col-sm-12 col-md-8 pl-4 pr-0 mt-2">
                                <fullscreen class="box-radius bg-white" style="height:140px">
                                    <div class="card-item bg-white text-auto">
                                        <div class="d-flex justify-content-between aline-items-center">
                                            <div class="fw-600 pr-5 fs-14">Current Qualifying Stage</div>
                                        </div>
                                        <div class="pearls row main-scroll pt-4">
                                            <div class="d-flex justify-content-center">
                                                <div v-for="(stage, stage_index) in profile_details" :key="stage_index">
                                                    <div v-if="stage.stage_status == 'pending'" class="pending" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'pending-b':stage_index == 0, 'pending-a':stage_index == no_of_stages-1}">
                                                        <div class="pearl-icon"></div>
                                                        <span class="pending-title px-2 text-truncate" :title="stage.stage_name">{{ stage.stage_name }}</span>
                                                    </div>
                                                    <div v-if="stage.stage_status == 'active'" class="active" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'active-b':stage_index == 0, 'active-a':stage_index == no_of_stages-1}">
                                                        <div class="pearl-icon"></div>
                                                        <span class="active-title px-2 text-truncate" :title="stage.stage_name">{{ stage.stage_name }}</span>
                                                    </div>
                                                    <div v-if="stage.stage_status == 'hold'" class="hold" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'hold-b':stage_index == 0, 'hold-a':stage_index == no_of_stages-1}">
                                                        <div class="pearl-icon"></div>
                                                        <span class="hold-title px-2 text-truncate" :title="stage.stage_name">{{ stage.stage_name }}</span>
                                                    </div>
                                                    <div v-if="stage.stage_status == 'complete'" class="complete" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'complete-b':stage_index == 0, 'complete-a':stage_index == no_of_stages-1}">
                                                        <div class="pearl-icon"></div>
                                                        <span class="complete-title px-2 text-truncate" :title="stage.stage_name">{{ stage.stage_name }}</span>
                                                    </div>
                                                    <div v-if="stage.stage_status == 'skip'" class="skip" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'skip-b':stage_index == 0, 'skip-a':stage_index == no_of_stages-1}">
                                                        <div class="pearl-icon"></div>
                                                        <span class="skip-title px-2 text-truncate" :title="stage.stage_name">{{ stage.stage_name }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-sm-12 col-md-12 pl-4 pr-0 mt-4">
                                <fullscreen class="box-radius bg-white pb-5">
                                    <div class="card-item bg-white text-auto pb-0" style="height: 378px !important;">
                                        <div class="d-flex justify-content-between aline-items-center">
                                            <div class="fw-600 pr-5 fs-14">Recent Activity</div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center" v-if="loadleadinteraction" style="height: 344px;">
                                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                        </div>
                                        <div  v-if="interactions.length == 0 && !loadleadinteraction" style="height:344px;">
                                            <h6 class="contentCenter pt-20 text-center h-100 fw-600 w-100">
                                                <img src="/static/images/images-new-theme/icons/activity_no_card_selected.png" alt="" width="150px" height="150px">
                                                <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Activities!</h5>
                                            </h6>
                                        </div>
                                        <div v-if="interactions.length > 0 && !loadleadinteraction" class="row pr-3 pt-2 pb-2 pl-3" style="height:340px;overflow-y: scroll !important;overflow-x: hidden !important;">
                                            <div>
                                                <div class="row pl-3">
                                                    <ul class="timeline mt-3">
                                                        <li class="event justify-content-between align-items-center" v-for="(interaction,index) in interactions" :key="index">
                                                            <div class="mb-2 lead-status pt-2 pl-4 pointer">
                                                                <div class="mt-1">
                                                                    <div class="fw-600 d-flex justify-content-between align-items-center fs-14 text-black mb-1 text-capitalize">
                                                                        <span class="text-truncate name-mx-width">
                                                                        </span>
                                                                        <!-- <span><i class="icon icon-check-circle text-green fs-30 ml-2"></i></span> -->
                                                                    </div>
                                                                    <div style="margin-top: -15px !important;" class="text-truncate">
                                                                        <span class="fw-500" style="font-size: 12px;color: #000">{{interaction.activity_name == "mark_stage_complete" ? interaction.stage_name.replace(/_/g, " ") : interaction.activity_name.replace(/_/g, " ")}}<span class="fw-500 pl-1 text-truncate" :title="interaction.details.title" style="font-size: 10px;color: #707070;">{{interaction.details.title.replace(/_/g, " ")}}</span></span>
                                                                        <!-- <span class="fw-600 text-capitalize" style="font-size: 8px;color: #219346;">Active </span>
                                                                        <span class="fw-600 text-capitalize" style="font-size: 8px;color: #000;">To </span> -->
                                                                        
                                                                    </div>
                                                                    <div style="margin-top: -8px !important;">
                                                                        <span class="fw-500" style="font-size: 10px;color: #707070">{{interaction.created_date}} |
                                                                            {{interaction.created_time_format}}</span>
                                                                    </div>
                                                                    <div class="fw-500"
                                                                        style="color: #707070;"></div>
                                                                </div>
                                                                <div class="lead-time mt-1"></div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                            <div class="col-lg-8 col-sm-12 col-md-12 pl-4 pr-0 mt-3">
                                <fullscreen class="box-radius bg-white">
                                    <div class="card-item bg-white text-auto">
                                        <div class="d-flex justify-content-between aline-items-center">
                                            <div class="fw-600 pr-5 fs-14">Product Associated</div>
                                            <div>
                                                <button :disabled="lead_type != 'Manual'" @click="addProductModalPopUp('new')"
                                                    class="btn btn-des-small ml-2 text-white" style="background:#008a63; height:30px">+ Products
                                                </button>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center" v-if="loadproductassociated" style="height:344px;">
                                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                        </div>
                                        <div v-else-if="lead_products.length == 0 && !loadproductassociated"  style="height:335px;">
                                            <h6 class="contentCenter pt-20 text-center h-100 fw-600 w-100">
                                                <img src="/static/images/dashboard/scm-product-image.png" alt="">
                                                <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Product Added!</h5>
                                            </h6>
                                        </div>
                                        <div v-else style="height:335px;overflow: hidden auto;">
                                            <div class="row pr-0">
                                                <div class="col-lg-4 col-sm-12 col-md-6 pb-3 mt-2" v-for="(product, product_index) in lead_products" :key="product_index">
                                                    <div class="widget widget2 product-cards bg-white text-auto">
                                                        <div style="padding-top:2px" class="text-truncate" :title="product.product_name "><img src="/static/images/dashboard/scm-product-image.png" style="height: 16px;" alt=""><span class="product-header pl-2" style="color: #00448b;">{{ product.product_name }}</span></div>
                                                        <!-- <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-1">
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Deal Associated </span>
                                                            <span class="mx-1">:</span>
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing text-truncate" style="font-size: 10px;">SME-02-030520</span>
                                                        </div>
                                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Deal Status</span>
                                                            <span class="mx-1">:</span>
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing text-truncate" style="font-size: 10px;">Stage 2</span>
                                                        </div> -->
                                                        <!-- <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-1" v-for="(template, template_index) in product.template_details" :key="template_index"> -->
                                                        <!-- <div class="row mt-2" v-if="product.template_details.length == 1">
                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                <p class="mb-1 text-truncate amt-max-width" :title="product.template_details[0].field_name">{{product.template_details[0].field_name}} : 
                                                                    <span v-if="product.template_details[0].field_type == 'checkbox'">
                                                                        <span v-for="(value, value_index) in product.template_details[0].value" :key="value_index">{{value}}
                                                                            <span v-if="product.template_details[0].value.length > 0 && value_index < product.template_details[0].value.length - 1">&nbsp;</span>
                                                                        </span>
                                                                    </span> 
                                                                    <span v-else>{{product.template_details[0].value}}</span></p>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="row mt-2" v-if="product.template_details.length > 1">
                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                <p class="mb-1 text-truncate amt-max-width" :title="product.template_details[0].field_name">{{product.template_details[0].field_name}} : 
                                                                    <span v-if="product.template_details[0].field_type == 'checkbox'">
                                                                        <span v-for="(value, value_index) in product.template_details[0].value" :key="value_index">{{value}}
                                                                            <span v-if="product.template_details[0].value.length > 0 && value_index < product.template_details[0].value.length - 1">&nbsp;</span>
                                                                        </span>
                                                                    </span> 
                                                                    <span v-else>{{product.template_details[0].value}}</span>
                                                                </p>
                                                                <p class="mb-1 text-truncate amt-max-width" :title="product.template_details[1].field_name">{{product.template_details[1].field_name}} :
                                                                    <span v-if="product.template_details[1].field_type == 'checkbox'">
                                                                        <span v-for="(value, value_index) in product.template_details[1].value" :key="value_index">{{value}}
                                                                            <span v-if="product.template_details[0].value.length > 0 && value_index < product.template_details[0].value.length - 1">&nbsp;</span>
                                                                        </span>
                                                                    </span> 
                                                                    <span v-else>{{product.template_details[1].value}}</span>
                                                                </p>
                                                            </div>
                                                        </div> -->
                                                        <!-- </div> -->
                                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-8 div-spacing" style="font-size: 10px;">Quantity</span>
                                                            <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-4 div-spacing text-truncate" :title="product.amount_inquired " style="font-size: 10px;padding-right: 10px !important;">{{ product.amount_inquired }}</span>
                                                        </div>
                                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-8 div-spacing" style="font-size: 10px;">Transaction Value Per Unit({{currency}})</span>
                                                            <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                            <span
                                                                class="text-left col-md-6 col-sm-6 col-lg-4 div-spacing text-truncate" :title="product.price_quoted " style="font-size: 10px;padding-right: 10px !important;">{{ product.price_quoted }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-12 col-sm-12 mt-4">
                        <div class="col-lg-12 col-sm-12 col-md-12 pl-0 pr-3">
                            <fullscreen class="box-radius bg-white leadFullscreen"  style="height:552px !important;overflow-y: auto;">
                                <div class="card-item bg-white text-auto">
                                    <div class="d-flex justify-content-between aline-items-center">
                                        <div class="fw-600 pr-5 fs-14">Meetings</div>
                                        <div><button class="btn-blue fw-600 px-2 pointer" @click="goToViewDetails">View All</button></div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center pt-25" v-if="loadupcomingmeeting">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <h6 v-if="meeting_details.length == 0 && !loadupcomingmeeting" class="contentCenter mt-30 text-center h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/schedule_meeting.svg" alt="" width="150px" height="150px">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Upcoming Meetings!</h5>
                                    </h6>
                                    <div v-if="meeting_details.length > 0 && !loadupcomingmeeting" class="upcoming-card row" v-for="(meeting, meeting_index) in meeting_details" :key="meeting_index">
                                        <div class="col-lg-4 col-md-4 col-sm-4" style="border-right: 1px solid #cdd2da;">
                                            <div v-if="meeting_index < 9" class="d-flex flex-column calendar-data justify-content-center" style="height:100%;">
                                                <div class="meeting-schedule" style="margin-left: 3px !important;">
                                                    <div class="fw-600 text-white" style="margin-left: 2px;padding-top: 2px">{{meeting.month}}</div>
                                                    <div class="fw-600 text-white pb-1" style="margin-left: 7px;">{{meeting.day}}</div>
                                                </div>
                                                <div >
                                                    <div v-if="meeting.weekday == 'Monday'" class="text-left" style="margin-left: 2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Tuesday'" class="text-left" style="margin-left: 0px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Wednesday'" class="text-left" style="margin-left: -10px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Thursday'" class="text-left" style="margin-left: -2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Friday'" class="text-left" style="margin-left: 8px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Saturday'" class="text-left" style="margin-left: -2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Sunday'" class="text-left" style="margin-left: 3px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                </div>
                                                <!-- <div>
                                                    <div class="text-left" style="font-size: 12px !important;margin-left: -11px !important;color: #00448b !important;">{{meeting.day_name == 'Wednesday' ? 'Wed' : meeting.day_name}}</div>
                                                    <div class="new-blue-text fw-500">{{meeting.schedule_start_time}}</div>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-8 mt-2">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div style="padding-top:2px" class="text-truncate" :title="meeting.meeting_title"><span style="font-size: 12px;color: #00448b;">{{meeting.meeting_title}}</span></div>
                                                <!-- <div><i class="icon icon-dots-vertical fs-16" style="color:#000"></i></div> -->
                                            </div>
                                            <div><span style="font-size: 12px;color: #00448b;">{{convertDate(meeting.start_date || "-")}}</span></div>
                                            <div class="pb-3 pt-1">
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 1">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 2">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 3">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[2].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[2].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                               <div class="d-flex align-items-center" v-if="meeting.invitees.length > 3">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[2].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[2].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <a href="#" class="symbol symbol-35px symbol-circle"  data-bs-toggle="modal" data-bs-target="#kt_modal_view_users">
                                                            <el-popover
                                                                v-if="meeting.invitees.length > 3"
                                                                placement="bottom"
                                                                min-width="200"
                                                                trigger="hover">
                                                                <div v-for="(invite, index) in meeting.invitees" :key="index" style="display: inline-block !important;">
                                                                    <div v-if="index > 2" class="fw-500 email-chips p-1 mt-1 ml-1">
                                                                        <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="invite.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="25" height="25" />
                                                                        <span class="fw-500 fs-12 pt-1 pl-1">{{invite.email}}</span>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0" style="padding: 0px !important;">
                                                                    <div class="symbol-label bg-dark fw-bold">
                                                                        +{{meeting.invitees.length - 3}}
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </a>
                                                    </div>
                                               </div>
                                            </div>
                                            <!-- <div class="d-flex align-items-center pt-1 pb-3">
                                                <span class="d-flex align-items-center">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png"  style="height:25px;width:25px;border-radius:15px;"/>
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" style="height:25px;width:25px;border-radius:15px;"/>
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" style="height:25px;width:25px;border-radius:15px;"/>
                                                </span>
                                                <div class="fw-500 mt-4px text-center text-secondary">
                                                    + more
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </fullscreen>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-sm-12 col-md-6 pl-4 pr-0 mt-4">
                        <fullscreen class="box-radius bg-white pb-5">
                            <div class="card-item bg-white text-auto pb-0" style="height: 220px;">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 pr-5 fs-14">Associated Call Report</div>
                                    <div>
                                        <!-- <button @click="addCallReport(category)" v-for="(category, index) in call_report_category_options"
                                        :key="index" 
                                            class="btn btn-des-small ml-2 text-white" style="background:#008a63; height:30px">+ Call Report
                                        </button> -->
                                        <button @click="addCallReport()"
                                            class="btn btn-des-small ml-2 text-white" :disabled="!userPermissions.call_reports.permitted_actions.create || lead_type != 'Manual'" style="background:#008a63; height:30px">+ Call Report
                                        </button>
                                    </div>
                                </div>
                                <div v-if="callreport_details.length == 0 && !loadcallreport" style="height:100% !important;">
                                    <h6 class="contentCenter text-center pt-5 h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/callreport_schedule.svg" height="100">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Call Report Added!</h5>
                                    </h6>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadcallreport" style="height:175px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row pr-3 pt-2 pb-2" style="height:175px;overflow-y: scroll !important;">
                                    <div class="col-lg-4 col-sm-12 col-md-6 mt-2 pr-0" v-for="(callreport,callreport_index) in callreport_details" :key="callreport_index">
                                        <div class="card-callreport">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div style="padding-top:2px"><span style="font-size: 12px;color: #00448b !important;"><i class="logo-crm fs-12 pr-1" style="color:#00448b !important"></i>{{callreport.call_report_number}}</span></div>
                                                <div @click="viewLeadsCallReport(callreport.call_report_id)"><i class="icon icon-eye text-secondary pointer vertical-align-middle-icon fs-18"></i></div>
                                            </div>
                                            <div style="margin-top: -1px !important;"><span class="callreport-text text-truncate fs-11">{{callreport.call_report_type  || "-"}}</span></div>
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div><span class="callreport-text fs-10 text-truncate"> {{callreport.last_modified_by_name  || "-"}}</span></div>
                                                <div><span class="callreport-text fs-10"> {{callreport.created_date || "-"}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <div class="col-lg-6 col-sm-12 col-md-6 pl-4 pr-6 mt-4">
                        <fullscreen class="box-radius bg-white pb-5">
                            <div class="card-item bg-white text-auto pb-0" style="height: 220px;">
                                <div class="d-flex justify-content-between aline-items-center mt-1">
                                    <div class="fw-600 pr-5 fs-14">Associated Expenses</div>
                                    <div>
                                        <button @click="addExpense"
                                            class="btn btn-des-small ml-2 text-white" :disabled="disableExpenseBtn || lead_type != 'Manual'" style="background:#008a63; height:30px">+ Expenses
                                        </button>
                                    </div>
                                </div>
                                <div style="height:100% !important;"  v-if="expense_details.length == 0 && !loadexpensereport">
                                    <h6 class="contentCenter text-center pt-5 h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/callreport_schedule.svg" height="100">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Expenses Added!</h5>
                                    </h6>
                                </div>
                               <div class="d-flex align-items-center justify-content-center" v-if="loadexpensereport" style="height:175px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row pr-3"  style="height:170px;overflow-y: scroll !important;">
                                    <div class="col-lg-4 col-sm-12 col-md-6 mt-2 pr-0" v-for="(expense,expense_index) in expense_details" :key="expense_index">
                                        <div class="card-expenses">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div class="text-truncate" :title="expense.expense_name" style="padding-top:2px"><span style="font-size: 12px;color: #00448b;">{{expense.expense_name}}</span></div>
                                                <div @click="viewLeadsExpenseReport(expense._id)"><i class="icon icon-eye text-secondary pointer vertical-align-middle-icon fs-18"></i></div>
                                            </div>
                                            <div><span class="expenses-text">{{expense.expense_type.replaceAll('_', ' ') || "-" }}</span></div>
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div><span class="expenses-text"> {{expense.transaction_date}}</span></div>
                                                <div><span class="expenses-text"> {{currency}} {{expense.transaction_amount}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
            </div>
        </div>
        <add-product v-if="add_product" @hideAddProductModal="hideAddProductModal" @closeLeadProducts="closeLeadProducts" modal_name="Add-Product" :lead_products="lead_products" :selected_lead_id="selected_lead_id" :edit_product="edit_product"></add-product>
        <view-leads-call-report :view_call_report_id="view_call_report_id" @selectedCallReports="selectedCallReports" v-if="show_view_call_reports" @hideViewCallReperts="hideViewCallReports" modal_name="view_leads_call_report"></view-leads-call-report>
        <!-- <schedule-meeting @updateLeads="loadMeetingsList()" :lead_current_stage="lead_current_stage" :lead_edit_stage="lead_edit_stage" :stage_edit_mode="stage_edit_mode" :meeting_id="meeting_id" v-if="schedule_meeting" @hideScheduleMeeting="hideScheduleMeeting" modal_name="schedule_meeting" :selected_lead_id="selected_lead_id"></schedule-meeting> -->
        <create-meeting :view_mode="view_mode" @SaveSchedule="SaveSchedule" v-if="createscheduleMeeting" :lead_current_stage="lead_current_stage" :reference_id="reference_id" :module_type="module_type" modal_name="createScheduleMeeting" @hideScheduleMeeting="hideScheduleMeetings"></create-meeting>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import { EventBus } from '../eventBus/nav-bar-event';
    import dashboard from '../mixins/dashboard'
    import { HalfCircleSpinner } from "epic-spinners";
    import { SweetModal } from 'sweet-modal-vue';
    import convert from "../mixins/convert.js";
    import leads from "../mixins/leads";
    import Settings from "../mixins/settings";
    import Expense from "../mixins/expense";
    import ViewLeadsCallReport from "./ViewLeadsCallReport.vue";
    import AddProduct from "./NewAddProduct.vue";
    import ScheduleMeeting from "./ScheduleMeeting";
    import globals from '../globals';
    import CreateMeeting from "../ScheduleMeeting/CreateScheduleMeeting";
    export default {
        data() {
            return {
                disableExpenseBtn: false,
                success_msg: "",
                warning_msg: "",
                expandprofile: false,
                ajaxCallInProgress: false,
                loadleadinteraction:false,
                loadproductassociated:false,
                loadcallreport:false,
                loadupcomingmeeting:false,
                loadexpensereport:false,
                lead_qualified: false,
                complete_stage_btn: false,
                is_all_stage_complete: false,
                is_all_stages_pending: false,
                lead_type: "",
                interaction_count : 0,
                profile_details: [],
                lead_details:[],
                interactions: [],
                phone_number: null,
                lead_products:[],
                current_stage: "",
                no_of_stages: 0,
                currency: "",
                product: [],
                course_of_action: [],
                callreport_details:[],
                meeting_details:[],
                lead_current_stage: "",
                lead_edit_stage: "",
                stage_edit_mode: "off",
                lead_stage:'',
                social_media:'',
                show_view_call_reports: false,
                view_call_report_id:'',
                expense_details:[],
                add_product: false,
                //call_report_category_options:[],
                loadMeetingSection:false,
                meeting_id: null,
                show_reminder: false,
                schedule_meeting:false,
                edit_product: false,
                createscheduleMeeting: false,
                module_type: "leads",
                reference_id:"",
                stage_details: ""
            }
        },
        components: {
            SweetModal,
            HalfCircleSpinner,
            ViewLeadsCallReport,
            AddProduct,
            ScheduleMeeting,
            CreateMeeting,
        },
        mixins: [dashboard, convert, leads, Settings, Expense],
        methods: {
            SaveSchedule(){
                this.loadMeetingsList()
            },
            goToViewDetails(){
                this.$router.push('/leads/schedulemeeting/'+this.module_type+'/'+this.selected_lead_id+'/'+this.stage_details);
            },
            hideScheduleMeetings(){
                this.createscheduleMeeting = false;
            },
            createSchedule(){
                this.view_mode = 'create'
                this.module_type = 'leads'
                this.createscheduleMeeting = true;
                setTimeout(() => {
                    this.$modal.show("createScheduleMeeting")
                }, 500);
            },
            // editLead(lead) {
            //     console.log(lead)
            //     if(lead.assigned_to_company == true){
            //         this.$router.push('/leads/createLeads/' + lead.id)
            //     }else{
            //         this.$router.push('/leads/createLeads/individual/' + lead.id)
            //     }

            // },
            convertDate(str) {
                var date = str.slice(0,11).split("-"),
                mnth = date[1],
                day = date[2],
                year = date[0];
                var newDate = [mnth,day,year].join("-");
                return newDate
            },
            refresh(){
                this.loadLeadProducts();
                this.loadLeadDetails();
                this.loadLeadInteraction();
                //this.getCallReportType();
                this.loadMeetingsList();
                this.loadCallReportsList();
                this.loadExpenseList();
            },
            addExpense(){
                window.open(globals.EXPENSE_URL + `/expense/create?from=leads&name=${this.lead_details.full_name}&id=${this.selected_lead_id}`, '_blank')
            },
            hideScheduleMeeting(){
                this.schedule_meeting = false
            },
            addScheduleMeeting(id){
                this.loadMeetingSection = true;
                this.meeting_id = null
                if(id){
                    this.meeting_id = id
                }
                this.schedule_meeting = true
                setTimeout(() => {
                    this.$modal.show("schedule_meeting")
                    this.loadMeetingSection = false;
                }, 500);
            },
            // getCallReportType() {
            //     this.$http.get("/call_report/get_call_report_category").then(res => {
            //         if (res.data.status_id == 1) {
            //             res.data.response.value.forEach(x => {
            //                 this.call_report_category_options.push(x.name);
            //             });
            //         }
            //     });
            // },
            addCallReport() {
                localStorage.setItem('callReportCategory', 'Sales Meeting')
                localStorage.setItem('lead_data', JSON.stringify(this.lead_details))
                let routeData = this.$router.resolve({name: 'callreport'});
                window.open(routeData.href+'callreport', '_blank');
            },
            hideAddProductModal(){
                this.add_product = false;
                this.loadLeadProducts();
            },
            closeLeadProducts(){
                this.add_product = false;
            },
            addProductModalPopUp(data){
                this.edit_product = false
                this.add_product = true;
                setTimeout(() => {
                    this.$modal.show("Add-Product");
                }, 500);
            },
            viewLeadsExpenseReport(id){
                window.open(globals.EXPENSE_URL + '/expense/view/' + id, '_blank')
            },
            viewLeadsCallReport(id){
                if(!this.userPermissions.call_reports.permitted_actions.view || !this.userPermissions.draft_call_reports.permitted_actions.view) {
                    this.$toasted.global.error("Permission Denied")
                } else {
                    this.view_call_report_id = null
                    if(id){
                        this.view_call_report_id = id
                    }
                    this.show_view_call_reports = true
                    setTimeout(() => {
                        this.$modal.show("view_leads_call_report")
                    }, 500);
                }

            },
            /**@params = value*/
            selectedCallReports(value){
                this.callreport_details = value
            },
            //hide the view call reports
            hideViewCallReports(){
                this.show_view_call_reports = false
            },
            viewLead(id){
                if(this.userPermissions.leads.permitted_actions.qualify){
                    this.$router.push('/leads/viewLeads/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                } 
            },
            async loadLeadProfileDetails(){
                this.ajaxCallInProgress = true
                //let type = localStorage.getItem("leads_type")
                let response
                if(this.lead_type == 'Manual'){
                    response = await this.getActiveLeadStageDetails(this.selected_lead_id)
                }else if(this.lead_type == 'Archive'){
                    response = await this.getArchiveLeadStageDetails(this.selected_lead_id)
                }
                else if(this.lead_type == 'Converted'){
                    response = await this.getConvertedLeadStageDetails(this.selected_lead_id)
                }
                this.profile_details = response.response;
                this.lead_current_stage = response.current_stage;
                if(this.lead_current_stage == 'qualified_lead'){
                    this.lead_stage = response.completed_stage;
                    this.lead_edit_stage = response.completed_stage;
                } else{
                    this.lead_stage = response.current_stage;
                    this.lead_edit_stage = response.current_stage;
                }
                this.no_of_stages = response.count;
                setTimeout(() => {
                    this.loadMeetingsList();
                    this.loadCallReportsList();
                    this.loadExpenseList();
                    this.$forceUpdate();
                }, 500);
                this.$forceUpdate();
                this.ajaxCallInProgress = false
            },
            // async loadLeadProfileDetails(){
            //     this.ajaxCallInProgress = true;
            //     let response
            //     if(this.lead_type == "Manual"){
            //         response = await this.getActiveLeadProfileData(this.selected_lead_id)
            //     } else if(this.lead_type == "Archive"){
            //         response = await this.getArchiveLeadProfileData(this.selected_lead_id)
            //     } else if(this.lead_type == "Converted"){
            //         response = await this.getConvertedLeadProfileData(this.selected_lead_id)
            //     }
            //     this.profile_details = response.response;
            //     this.product = this.profile_details.product
            //     this.course_of_action = this.profile_details.course_of_action
            //     this.current_stage = response.current_stage;
            //     this.no_of_stages = response.count;
            //     this.lead_current_stage = response.current_stage;
            //     this.loadMeetingsList();
            //     this.loadCallReportsList();
            //     this.loadExpenseList();
            //     this.$forceUpdate();
            //     this.ajaxCallInProgress = false;
            // },
            async loadLeadDetails(){
                this.ajaxCallInProgress = true
                let type = localStorage.getItem("leads_type")
                let response
                if(this.lead_type == "Manual"){
                    response = await this.getLeadActiveDetails(this.selected_lead_id)
                } else if(this.lead_type == "Archive"){
                    response = await this.getLeadArchiveDetails(this.selected_lead_id)
                } else if(this.lead_type == "Converted"){
                    response = await this.getLeadConvertedDetails(this.selected_lead_id)
                }
                this.lead_details = response.response;
                this.social_media = response.response.source;
                this.phone_number = this.lead_details.lead_number.phone_number
                this.ajaxCallInProgress = false
            },
            async loadLeadProducts(){
                this.loadproductassociated = true;
                let response
                if(this.lead_type == "Manual"){
                    response = await this.getLeadProducts(this.selected_lead_id)
                } else if(this.lead_type == "Archive"){
                    response = await this.getArchiveLeadProducts(this.selected_lead_id)
                } else if(this.lead_type == "Converted"){
                    response = await this.getConvertedLeadProducts(this.selected_lead_id)
                }
                this.lead_products = response.response;
                this.loadLeadInteraction();
                this.loadproductassociated = false;
            },
            async loadLeadInteraction() {
                this.loadleadinteraction = true
                /**@params = skip, @params = limit, @params = sort_value,@params = sort_key, @params = lead_id*/
                let params = {
                    skip: 0,
                    limit: 10,
                    sort_value: 1,
                    sort_key: "id",
                    lead_id: this.selected_lead_id
                }
                let type = localStorage.getItem("leads_type");
                let response
                if (type == 'Manual') {
                    response = await this.getLeadInteraction(params)
                } else if (type == 'Converted') {
                    response = await this.getConvertedLeadInteraction(params)
                } else {
                    response = await this.getArchiveLeadInteraction(params)
                }
                this.interactions = response.response.interaction
                this.interaction_count = this.interactions.length
                this.interactions.forEach(x => {
                    // x["unique_id"] = uuid
                    x['created_time_format'] = new Date(x.created_time)
                    x['created_date'] = new Date(x.created_time)
                    x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                    })
                    var date = new Date(x.created_time_format);
                    var hours = date.getHours();
                    var minutes = date.getMinutes();

                    // Check whether AM or PM
                    var newformat = hours >= 12 ? 'PM' : 'AM';

                    // Find current hour in AM-PM Format
                    hours = hours % 12;

                    // To display "0" as "12"
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                })
                this.loadleadinteraction = false
            },
            async loadCallReportsList(data){
                this.loadcallreport = true;
                /**@params = skip, @params = limit, @params = search_key, @params = sort_value, @params = sort_key,@params = lead_id*/
                let params = {
                    skip: 0,
                    limit: 9,
                    search_key: "",
                    sort_value: 1,
                    sort_key: "id",
                    lead_id: this.selected_lead_id,
                }
                if(data){
                    params.stage_name = data
                } else {
                    params.stage_name = this.lead_current_stage == 'qualified_lead' ? this.lead_stage : this.lead_current_stage
                }
                if(this.stage_edit_mode == 'on'){
                    params.stage_name = this.lead_edit_stage
                }
                let response
                if(this.lead_type == "Manual"){
                    response = await this.getLeadsCallReportList(params)
                } else if(this.lead_type == "Archive"){
                    response = await this.getArchiveLeadsCallReportList(params)
                } else if(this.lead_type == "Converted"){
                    response = await this.getConvertedLeadsCallReportList(params)
                }
                this.callreport_details = response.response;
                this.callreport_details.forEach(x => {
                    // x["unique_id"] = uuid
                    x['created_time_format'] = new Date(x.last_modified_time)
                    x['created_date'] = new Date(x.last_modified_time)
                    x.created_date = new Date(x.last_modified_time).toLocaleString('en-us', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric'
                    })
                    var date = new Date(x.created_time_format);
                    var hours = date.getHours();
                    var minutes = date.getMinutes();

                    // Check whether AM or PM
                    var newformat = hours >= 12 ? 'PM' : 'AM';

                    // Find current hour in AM-PM Format
                    hours = hours % 12;

                    // To display "0" as "12"
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                })
                this.loadLeadInteraction(data);
                this.loadcallreport = false;
            },
            async loadMeetingsList(data){
                this.loadupcomingmeeting = true
                let params = {
                    "product_name": "CRM",
                    "skip": 0,
                    "limit": 10,
                    "search_key": "",
                    "reference_id": this.selected_lead_id,
                }
                if(data){
                    params.stage_name = data
                    this.stage_details = data
                } else {
                    params.stage_name = this.lead_current_stage == 'qualified_lead' ? this.lead_stage : this.lead_current_stage
                    if(this.lead_current_stage == 'qualified_lead'){
                        this.stage_details = this.lead_stage
                    }else{
                        this.stage_details = this.lead_current_stage
                    }
                }
                if(this.stage_edit_mode == 'on'){
                    params.stage_name = this.lead_edit_stage
                    this.stage_details = this.lead_edit_stage
                }
                let response = await this.getLeadsMeetingList(params);
                this.meeting_details = response.response
                this.loadLeadInteraction();
                this.loadupcomingmeeting = false
            },
            // async loadMeetingsList(data){
            //     this.loadupcomingmeeting = true;
            //     /**@params = skip, @params = limit, @params = search_key, @params = sort_value, @params = sort_key,@params = lead_id*/
            //     let params = {
            //         skip: 0,
            //         limit: 10,
            //         search_key: "",
            //         sort_value: 1,
            //         sort_key: "id",
            //         lead_id: this.selected_lead_id,
            //     }
            //     if(data){
            //         params.stage_name = data
            //     } else {
            //         params.stage_name = this.lead_current_stage == 'qualified_lead' ? this.lead_stage : this.lead_current_stage
            //     }
            //     if(this.stage_edit_mode == 'on'){
            //         params.stage_name = this.lead_edit_stage
            //     }
            //     let response
            //     if(this.lead_type == "Manual"){
            //         response = await this.getLeadsMeetingsList(params)
            //     } else if(this.lead_type == "Archive"){
            //         response = await this.getLeadsArchiveMeetingsList(params)
            //     } else if(this.lead_type == "Converted"){
            //         response = await this.getLeadsConvertedMeetingsList(params)
            //     }
            //     this.meeting_details = response.response.meetings;
            //     var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            //     this.meeting_details.forEach(x => {
            //         x['d'] = new Date(x.schedule_start_date);
            //         x['day_name'] = days[x.d.getDay()];
            //         x['month_name'] = x.d.getMonth() + 1;
            //         x['get_date'] = x.d.getDate();
            //         x['created_time_format'] = parseFloat(x.schedule_start_time)
            //         var date = new Date(x.created_time_format);
            //         var hours = date.getHours();
            //         var minutes = date.getMinutes();
            //         // Check whether AM or PM
            //         var newformat = hours >= 12 ? 'PM' : 'AM';
            //         // Find current hour in AM-PM Format
            //         hours = hours % 12;
            //         // To display "0" as "12"
            //         hours = hours ? hours : 12;
            //         minutes = minutes < 10 ? '0' + minutes : minutes;
            //         x.created_time_format = hours + ':' + minutes + ' ' + newformat;
            //         if(x.month_name == 1){
            //             x.month_name = "Jan"
            //         }
            //         else if(x.month_name == 2){
            //             x.month_name = "Feb"
            //         }
            //         else if(x.month_name == 3){
            //             x.month_name = "Mar"
            //         }
            //         else if(x.month_name == 4){
            //             x.month_name = "Apr"
            //         }
            //         else if(x.month_name == 5){
            //             x.month_name = "May"
            //         }
            //         else if(x.month_name == 6){
            //             x.month_name = "Jun"
            //         }
            //         else if(x.month_name == 7){
            //             x.month_name = "Jul"
            //         }
            //         else if(x.month_name == 8){
            //             x.month_name = "Aug"
            //         }
            //         else if(x.month_name == 9){
            //             x.month_name = "Sep"
            //         }
            //         else if(x.month_name == 10){
            //             x.month_name = "Oct"
            //         }
            //         else if(x.month_name == 11){
            //             x.month_name = "Nov"
            //         }
            //         else if(x.month_name == 12){
            //             x.month_name = "Dec"
            //         }
            //     })
            //     this.loadLeadInteraction();
            //     this.loadupcomingmeeting = false;
            // },
            async loadExpenseList(){
                try {
                    this.loadexpensereport = true;
                    /**@params = skip, @params = limit, @params = search_key, @params = sort_value, @params = sort_key,@params = lead_id*/
                    let params = {
                        "limit": 9,
                        "my_expense": true,
                        "search_key": "",
                        "skip": 0,
                        "filter_json" :{
                            "expense_created_for": [
                                this.selected_lead_id,
                            ]
                        }
                    }
                    let response = await this.getexpenseList(params)
                    this.expense_details = response.response.expense_details;
                    this.loadexpensereport = false;
                }
                catch(err) {
                    if(err === 'UnAuthorized Request: Access Denied'){
                        this.disableExpenseBtn = true;
                    }
                    this.loadexpensereport = false;
                }
            },
            expandProfile(){
                this.expandprofile = !this.expandprofile;
            },
            
        },
        mounted(){
            console.log(this.userPermissions)
            let data = this.$route.params.data;
            this.selected_lead_id = localStorage.getItem("selected_lead_id")
            this.reference_id = this.selected_lead_id
            this.ajaxCallInProgress = true;
            this.lead_type = localStorage.getItem("leads_type")
            this.currency = this.loggedInUser.currency.symbol;
            this.loadLeadProfileDetails();
            this.loadLeadProducts();
            this.loadLeadDetails();
            //this.loadLeadInteraction();
            //this.getCallReportType();
        },
        computed:{
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },

    }
</script>
<style scoped>
    .table-lead thead tr th:first-child{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
     .table-lead thead tr th:last-child{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .hot_lead {
        background: #fce5e5;
        color: #e82828;
        border: solid 1px #e82828;
        border-radius: 5px;
        padding: 6px 34px 6px 17px;
    }

    .warm_lead {
        background: #ffecd1;
        color: #ff9a06;
        border: solid 1px #ff9a06;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }

    .cold_lead {
        background: #c5daf8;
        color: #00448b;
        border: solid 1px #00448b;
        border-radius: 5px;
        padding: 6px 26px 6px 17px;
    }

    .hello {
        width: 100%;
        height: 500px;
    }

    .card-item {
        padding: 18px;
        border-radius: 6px;
    }

    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }

    .ml-32px {
        margin-left: 32px;
    }

    #territoryDiv {
        width: 100%;
        height: 365px;
        background-image: linear-gradient(to bottom, #003e96, #001f4b);
    }

    #convertedLeadDiv {
        width: 100%;
        height: 405px;
    }

    #convertedDataDiv {
        width: 100%;
        height: 200px;
    }

    #campaignDiv {
        width: 100%;
        height: 340px;
    }

    #targetDiv {
        width: 100%;
        height: 340px;
    }

    #contactDiv {
        width: 100%;
        height: 400px;
    }

    .logo-image {
        width: 40px;
        height: 55px;
    }

    .contracts-logo {
        position: relative;
        bottom: 20px;
    }

    .pb-10px {
        padding-bottom: 10px;
    }

    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }

    .meetings {
        border: 1px solid #005dae;
        border-radius: 4px;
        padding-top: 8px;
    }

    #targetachievedDiv {
        width: 100%;
        height: 300px;
    }

    #trendsDiv {
        width: 100%;
        height: 345px;
    }

    #salesValue {
        width: 100%;
        height: 340px;
    }

    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }

    #days {
        cursor: pointer;
    }

    .expand-img {
        width: 18px;
        margin-bottom: 2px;
    }

    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }

    .icon-images {
        width: 24px;
        padding-right: 10px;
    }

    .copy-icon-images {
        width: 30px;
    }

    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }

    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }

    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }

    .contactMedia {
        width: 100%;
        height: 280px !important;
    }

    .new-blue {
        color: #00448b !important;
    }

    .slant-tabs {
        position: relative;
        height: 40px;
        min-width: 100px !important;
        text-align: center;
        line-height: 44px;
        color: #7b7f97;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .new-blue {
        background-color: #e5eaed
    }

    .div-space {
        padding-right: 8px !important;
        padding-left: 5px !important;
    }

    .text-data {
        text-transform: capitalize !important;
    }

    .dropdown-button {
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }

    .dropdown-button:focus {
        border: 1px solid #0F5DAF !important;
    }

    .dropdown-toggle::after {
        font-size: 20px;
    }

    .dropdown-button span {
        color: #000;
        font-weight: 400;
    }

    .dropdown-submenu {
        position: relative;
        padding: 0;
    }

    .dropdown-item-toggle {
        margin-right: 5px;
    }

    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }

    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }

    .sub-dropdown {
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }

    .dropdown-label {
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }

    .select-css {
        border-radius: 6px;
        border: 0.6px solid #d7dae2 !important;
    }

    .el-select.drop-data .el-input__icon {
        line-height: 0px !important
    }

    .box-radius {
        border-radius: 7px !important;
    }

    .trendsDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 0 !important;
    }

    .contactDiv-expand {
        width: 100%;
        height: 600px !important;
        margin: auto;
        vertical-align: middle;
    }

    #historyDiv {
        height: 90px !important;
    }

    .trendsDiv-expand,
    .territoryDiv-expand,
    .convertedLeadDiv-expand,
    .historyDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    #salesValue {
        width: 100%;
        height: 400px;
    }

    .table-lead {
        border-collapse: collapse;
        width: 100%;
        height: 854px;
    }

    table thead th {
        padding: 10px;
        letter-spacing: 0.86px;
    }

    table.table-lead tbody tr {
        border-bottom: solid 1px #f2f3f5;
    }

    table.table-lead tbody td {
        padding: 16px 10px !important;
        font-size: 14px;
        color: #206ad3;
    }

    .badgelead {
        display: inline-block;
        padding: 6px 6px;
        font-size: 13px;
        font-weight: normal;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        width: 100px;
    }

    .badgelead-hotlead {
        background: #fce5e5;
        border: 0.5px solid #e82828;
        color: #e82828;
    }

    .badgelead-coldlead {
        background: #c5daf8;
        border: 0.5px solid #206ad3;
        color: #206ad3;
    }

    .badgelead-warmlead {
        background: #ffecd1;
        border: 0.5px solid #ff9a06;
        color: #ff9a06;
    }
    .leadFullscreen.fullscreen {
        overflow-y:scroll !important;
    }
    .leadFullscreen.fullscreen .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 300px;
        width: 300px;
        white-space: nowrap;
    }

    .leadFullscreen.fullscreen .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        width: 200px;
        white-space: nowrap;
    }
    .list-lead-img{
        width: 100% !important;
        height: 50% !important;
        margin-top: -300px !important;
    }
    .card-expenses{
        background-color: #cce3fc;
        border: 1px solid #206ad3;
        border-radius: 6px;
        height: 70px;
        padding: 5px;
    }
    .expenses-text{
        font-size: 10px;
        color: #89898d;
    }
    .card-callreport{
        background-color: #fff;
        border: 1px solid #206ad3;
        border-radius: 6px;
        height: 70px;
        padding: 5px;
    }
    .callreport-text{
        font-size: 10px;
        color: #89898d;
    }
    .product-cards {
        border: 1px solid #00448b;
        padding: 5px !important;
        border-radius: 6px;
        min-height: 80px;
    }
    .div-spacing {
        padding-left: 0px !important;
        padding-right: 0px !important;
        color: #3f3f3f !important;
    }
    .product-header{
        font-size: 12px;
        color: #206ad3;
        font-weight: 500
    }
    .upcoming-card {
        height: 100%;
        margin: 10px 0 0 0;
        padding: 0px;
        border-radius: 8px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
    }
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .step-title{
        position: absolute;
    }
    .call-report-div{
        margin-left: 20px;
        border: 1px solid #0D75E8;
        border-radius: 8px;
        padding: 2px 12px;
        box-shadow: 1px 1px 2px darkgrey;
    }
    .pearls {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0 0 0px;
        justify-content: center;
    }
    .pearl {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearle {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearles {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .pearl:before, .pending:before, .active:before, .hold:before, .complete:before, .skip:before {
        left: 0;
    }
    .pearl:after, .pearl:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearle:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearles:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        margin-left: -36%;
        background-color: #eee;
    }
    .pearl-icon {
        font-size: 18px;
    }
    .pearl-icon, .pearl-number {
        position: relative;
        z-index: 1;
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 32px;
        color: #fff;
        text-align: center;
        background: #bdbdbd;
        border-radius: 50%;
        border: 5px solid #fff;
        outline: 5px solid #bdbdbd;
    }
    .icon {
        display: inline-block;
        font-style: normal;
        font-weight: 400;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
        line-height: 1;
    }
    .pearl-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #616161;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .pending {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .active {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .hold {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .complete {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .skip {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .pending .pearl-icon{
        color: #c4c4c4;
        background-color: #c4c4c4;
        border-color: #fff;
        outline: 5px solid #c4c4c4;
    }
    .active .pearl-icon{
        color: #FFBF02;
        background-color: #FFBF02;
        border-color: #fff;
        outline: 5px solid #FFBF02;
    }
    .hold .pearl-icon{
        color: #E25251;
        background-color: #E25251;
        border-color: #fff;
        outline: 5px solid #E25251;
    }
    .complete .pearl-icon{
        color: #1D8A5F;
        background-color: #1D8A5F;
        border-color: #fff;
        outline: 5px solid #1D8A5F;
    }
    .skip .pearl-icon{
        color: #676767;
        background-color: #676767;
        border-color: #fff;
        outline: 5px solid #676767;
    }

    .pending:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .pending:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .active:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .active:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .hold:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }
    .hold:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }

    .complete:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .complete:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .skip:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .skip:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .pending-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .pending-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .active-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .active-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .hold-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }
    .hold-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }

    .complete-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .complete-a:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .skip-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .skip-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .pending-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #c4c4c4;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .active-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #FFBF02;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .hold-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #E25251;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .complete-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #1D8A5F;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .skip-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #676767;
        margin-bottom: 0;
        line-break: anywhere;
    }
   @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 70px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 85px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 200px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 95px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 110px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 190px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 280px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 115px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 175px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 230px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 340px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1441px) and (max-width: 1699px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 145px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 195px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 260px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 390px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1700px) and (max-width: 1920px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 155px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 170px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 233px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 310px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 465px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
    .circle-button {
        height: 23px;
        width: 23px;
        background-color: #00448b;
        border-radius: 50%;
        display: inline-block;
        margin-top: -4px;
        padding-right: 24px !important;
    }
    .timeline {
        border-left: 2px solid #00448b;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        background: rgba(255, 255, 255, 0.03);
        color: rgba(255, 255, 255, 0.8);
        padding: 0px 0px 8px 0px !important;
        position: relative;
        line-height: 1.4em;
        overflow-x: initial;
        font-size: 14px;
        list-style: none;
        text-align: left;
        font-weight: 100;
        margin-left: 6px !important;
        max-width: 100% !important;
    }

    .timeline h3 {
        color: #303031 !important;
    }

    .timeline p {
        color: #303031 !important;
    }

    .timeline h1 {
        font-weight: 100;
        font-size: 1.4em;
    }

    .timeline h2,
    .timeline h3 {
        font-weight: 400;
        font-size: 16px;
    }

    .timeline .event {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        padding-bottom: 0px;
        margin-bottom: 0px;
        position: relative;
    }

    .timeline .event:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .timeline .event:before,
    .timeline .event:after {
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event:before {
        left: -217.5px;
        color: #303031 !important;
        content: attr(data-date);
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
    }

    .timeline .event:after {
        left: -13.6px;
        background: #ffffff;
        border-radius: 50%;
        height: 25px;
        width: 25px;
        content: "";
        top: 0px;
        border: 8px solid #00448b;
        box-shadow: 0 0 5px 0 #71acff;
    }

    .timeline .event-completed:after {
        font-family: 'fuse-iconfont';
        left: -13.6px;
        background: #34ac3d !important;
        border-radius: 50%;
        height: 25px;
        width: 25px;
        content: "\ea7b";
        color: #fff;
        padding-top: 5px;
        font-size: 28px;
        top: 5px;
        border: 6px solid #34ac3d !important;
        box-shadow: 0 0 5px 0 #34ac3d !important;
    }

    .timeline .event .today-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event .date-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 19px;
    }
    .meeting-schedule{
        background-image: url("https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/schedule.svg");
        background-repeat: no-repeat;
        background-size: contain;
        padding-left: 10px;
        padding-top: 4px;
        width: 45px !important;
        margin-left: -6px !important;
    }
    .social-media-icons{
      width: 1.5em;
      height: 1.5em;
    }
    .email-chips{
        display: inline-flex;
        background: #dfe8f4;
        margin-bottom: 8px;
        border-radius: 25px;
        cursor: pointer;
        color: #4e5764;
    }
    .symbol-group {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-left: 10px;
    }
    .flex-nowrap {
        flex-wrap: nowrap!important;
    }
    .symbol-group.symbol-hover .symbol {
        cursor: pointer;
    }
    .symbol-group .symbol {
        position: relative;
        z-index: 0;
        margin-left: -6px;
        transition: all .3s ease;
    }
    .symbol-group .symbol:hover {z-index: 1;}
    .symbol.symbol-circle, .symbol.symbol-circle .symbol-label, .symbol.symbol-circle>img {
        border-radius: 50%;
    }
    .symbol {
        display: inline-block;
        flex-shrink: 0;
        position: relative;
        border-radius: 0.475rem;
        text-decoration: none !important;
    }
    .symbol.symbol-35px .symbol-label {
        
        width: 28px;
        height: 28px;
        font-size: 10px;
        font-weight: 600 !important;
    }
    .symbol-group .symbol-label {
        position: relative;
        color: #fff !important;
        text-decoration: none !important;
    }
    .symbol .symbol-label {
        display: flex;
        align-items: center;
        justify-content: center;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        border-radius: 0.475rem;
    }
    .bg-dark {
        background-color: #00448b !important;
    }
    .btn-blue{
        background-color: #00448b;
        color: #fff;
        border-radius: 4px;
        font-size: 12px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/LeadProfileDashboard.vue